import React from 'react';
import DesktopPanel from '../DropdownPanel/DesktopPanel.js';
import { s as styleInject } from '../../style-inject.es-746bb8ed.js';
import 'wix-rich-content-common';
import 'wix-rich-content-ui-components';
import 'ricos-context';

var css_248z = "._98nVi{box-sizing:border-box;display:flex;flex-direction:column;width:162px;z-index:10}[dir] ._98nVi{background-color:#fff}._98nVi *,._98nVi :after,._98nVi :before{box-sizing:inherit}._98nVi input{box-sizing:border-box}@media only screen and (max-width:640px){._98nVi{width:100%}}";
var styles = {"modal":"_98nVi"};
styleInject(css_248z);

const DropdownModal = ({ options }) => {
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ React.createElement("div", { tabIndex: -1, className: styles.modal }, /* @__PURE__ */ React.createElement(DesktopPanel, { options }))
  );
};

export { DropdownModal as default };
//# sourceMappingURL=DropdownModal.js.map
